// src/oura/components/newscan/healthCheck.ts
//
// Whether every fact on the Review health line is met (a green tick, no amber
// dot). The Review head reads it so it never says "every check passed" above
// an amber fact. Mirrors the `ok` of each fact in HealthLine.tsx: change both
// together.

import type { ScanDraft } from "@service/aeo/scanDraftTypes";
import { brandShapeOk, homeHoldsFewest, isBrandSet, openSlots, traceCounts } from "./brandReview";

/** True when the health line shows an amber dot for at least one fact. */
export function healthHasUnmet(draft: ScanDraft): boolean {
    const b = draft.business;
    const location = draft.questions.filter((q) => q.check === "location");

    if (isBrandSet(draft)) {
        const trace = traceCounts(draft);
        return (
            !brandShapeOk(draft) ||
            !homeHoldsFewest(draft) ||
            (trace !== null && trace.traced !== trace.total) ||
            openSlots(draft, "category_in_problem_row").length > 0 ||
            openSlots(draft, "claim_in_question").length > 0 ||
            openSlots(draft, "place_in_brand_row").length > 0
        );
    }

    if (b.buy === "online") {
        const market = (b.market ?? "").toLowerCase();
        const missing = market ? location.filter((q) => !q.text.toLowerCase().includes(market)).length : 0;
        if (missing > 0) return true;
    } else {
        const outlets = b.outlets.filter((o) => o.name.trim() && (o.source === "site" || o.confirmed === true));
        const asked = new Set(location.map((q) => q.fill.toLowerCase()));
        const k = outlets.filter((o) => asked.has(o.name.trim().toLowerCase())).length;
        if (outlets.length > 0 && k !== outlets.length) return true;
    }

    const cap = draft.words.find((w) => w.capWarn)?.capWarn ?? null;
    return Boolean(cap && cap.used > cap.warnAbove);
}
